import { render, staticRenderFns } from "./SbbAssetMarkerCluster.vue?vue&type=template&id=63f8beb8&"
import script from "./SbbAssetMarkerCluster.vue?vue&type=script&lang=js&"
export * from "./SbbAssetMarkerCluster.vue?vue&type=script&lang=js&"
import style0 from "./SbbAssetMarkerCluster.vue?vue&type=style&index=0&id=63f8beb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports